const MenuHelpCenter = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M5.47867 16.8772C5.47867 16.8772 4.12157 18.1619 4.00889 18.6968C3.89621 19.2317 4.89566 18.8961 4.89566 18.8961L7.09543 18.1514C7.09543 18.1514 9.93211 19.5987 12.4209 18.6758C14.9098 17.7529 16.7666 16.3791 17.3545 12.3834C17.9424 8.38766 14.2582 4.96875 10.6768 5.00022C7.84991 5.02643 4.5723 6.4737 4.19506 11.6912C4.19012 13.5105 4.63284 15.2991 5.47867 16.8772Z"
            fill="#534E46"
            stroke="#534E46"
            strokeWidth="2.5"
            strokeMiterlimit="10"
        />
        <path
            className="help-center-cut"
            d="M9.6642 13.7501L9.94116 12.7706C9.94116 12.7706 12.6691 12.8931 13.1723 11.13C13.6754 9.36702 12.5445 8.45122 11.7552 8.05944C11.0351 7.70194 8.88412 7.88804 8.63025 10.1261"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M17.9271 5L16.7605 6.16667"
            fill="none"
            stroke="#534E46"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M19.6771 6.75L17.9271 7.91667"
            fill="none"
            stroke="#534E46"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M20.2605 9.08325H18.5105"
            fill="none"
            stroke="#534E46"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            className="help-center-cut"
            d="M9.5973 15.7847C9.60354 15.7181 9.60354 15.6448 9.60042 15.5715C9.55984 14.8789 9.04794 15.0187 9.01984 15.6515C9.01048 15.9112 9.09476 16.171 9.21337 16.2442C9.40377 16.3641 9.5692 16.151 9.5973 15.7847Z"
            fill="none"
            stroke="white"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default MenuHelpCenter
